import DocumentTitle from "react-document-title";
import BackButton from "@/components/buttons/BackButton";
import { WealthReaderFlow } from "./Utils/WealthReaderFlow/WealthReaderFlow";
import PlanesExternosDataReceived from "./Utils/PlanesExternosDataReceived/PlanesExternosDataReceived";
import {
  PLANES_EXTERNOS_DESCRIPTION,
  TPlanesExternos,
} from "./Texts/PlanesExternos";
import { useState } from "react";
import { TWRPortfolio } from "@/services/WealthReaderService";

const BASE_CLASS = "planesExternos";

const PlanesExternos: React.FC = () => {
  const [wRData, setWRData] = useState<TWRPortfolio[]>();

  return (
    <DocumentTitle title="IronIA - Planes Externos">
      <div className={BASE_CLASS}>
        <BackButton />
        {!wRData ? (
          <>
            <WealthReaderFlow wrItem={setWRData} />
            <div className={`${BASE_CLASS}__infoContainer`}>
              <h2>Planes externos</h2>
              {PLANES_EXTERNOS_DESCRIPTION.map((planes: TPlanesExternos) => (
                <p className={`${BASE_CLASS}__text`}>{planes.text}</p>
              ))}
            </div>
          </>
        ) : (
          <>
            <div>
              <span>Detalles de la cartera</span>
              <PlanesExternosDataReceived wRData={wRData} />
            </div>
          </>
        )}
      </div>
    </DocumentTitle>
  );
};

export default PlanesExternos;
